<template>
  <div id="manageClass">
    <div class="allBodyDiv">
      <div style="margin-top: 15px">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item :to="{ path: '/manageclass' }"
            >首页</el-breadcrumb-item
          >
          <el-breadcrumb-item>{{ $route.query.name }}</el-breadcrumb-item>
        </el-breadcrumb>
      </div>

      <el-row class="manageClassBody" :gutter="20">
        <el-col :span="24" class="leftMember">
          <el-card class="box-card">
            <div slot="header" class="clearfix">
              <i class="blueI" style="left: 10px"></i>

              <div style="display: inline-block">
                <span class="cardHeader">{{ $route.query.name }}</span>
              </div>

              <div class="fr" style="margin-right: 41%">
                <el-radio-group v-model="radio3" @change="getNewData()">
                  <el-radio-button :label="1">综合统计</el-radio-button>
                  <el-radio-button :label="2">单次统计</el-radio-button>
                </el-radio-group>
              </div>
            </div>
            <div style="margin-top: 30px">
              <div style="position: relative">
                <div>
                  <div v-if="radio3 == 1">
                    <div style="position: absolute">
                      <span
                        ><img
                          src="/static/images/exam/quxian.png"
                          alt=""
                          align="top"
                      /></span>
                      分数曲线
                    </div>
                    <ve-line
                      id="canvas"
                      :data="chartData"
                      :settings="chartSettings"
                    ></ve-line>
                  </div>

                  <div v-else style="margin-bottom: 20px">
                    <div>
                      <el-row
                        style="
                          padding-bottom: 10px;
                          border-bottom: 1px solid #ebedf3;
                        "
                      >
                        <div
                          v-for="i in listData"
                          :key="i.id"
                          :class="{ testCard: true, activeTest: i.active }"
                          style="
                            margin-bottom: 20px;
                            width: 210px;
                            height: 86px;
                          "
                          @click="getNewData(i.examinationId)"
                        >
                          <div style="height: 48px" class="ellipsis" :title="i.group_name">
                            {{ i.group_name }}
                          </div>
                          <div :title="i.push_time + i.average_score + '分'">
                            <span>{{ i.ymd }}</span>
                            <span>{{ i.avgScore.toFixed(1) }}分</span>
                          </div>
                        </div>
                      </el-row>
                    </div>
                  </div>
                </div>

                <div
                  style="height: 25px; line-height: 25px; margin-bottom: 15px"
                >
                  <span
                    ><img
                      src="/static/images/exam/defen.png"
                      alt=""
                      align="top"
                  /></span>
                  得分细则
                </div>

                <div v-if="radio3 == 1">
                  <div class="tableDataHeader">
                    <div style="width: 439px">实验步骤</div>
                    <div style="width: 437px">实验操作</div>
                    <div style="width: 279px">错误人数</div>
                  </div>
                  <div class="scoreRuleTable">
                    <div v-for="i in asList" :key="i.id">
                      <div class="dataTitle">{{ i.step_name }}</div>
                      <div class="dataList">
                        <div
                          class="dataBody"
                          v-for="a in i.itemStep"
                          :key="a.id"
                        >
                          <div class="stepName">{{ a.step_name }}</div>
                          <div
                            class="errorNum"
                            :style="{ color: a.error_nums <= 0 ? '' : 'red' }"
                          >
                            {{ a.error_nums }}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div v-else>
                  <div class="tableDataHeader">
                    <div style="width: 439px">实验步骤</div>
                    <div style="width: 437px">实验操作</div>
                    <div style="width: 279px">错误人数</div>
                  </div>
                  <div class="scoreRuleTable">
                    <div v-for="i in asList" :key="i.id">
                      <div>
                        <div class="dataTitle">{{ i.step_name }}</div>
                        <div class="dataList">
                          <div
                            class="dataBody"
                            v-for="a in i.itemStep"
                            :key="a.id"
                          >
                            <div class="stepName">{{ a.step_name }}</div>
                            <div
                              class="errorNum"
                              :style="{ color: a.error_nums <= 0 ? '' : 'red' }"
                            >
                              {{ a.error_nums }}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </el-card>
        </el-col>
      </el-row>
    </div>
  </div>
</template>
<script>
import {
  getusertestexamcount,
  gettestrecord,
  getClassExamListInfo,
  getClassExperimentStatistics,
  getClassExamInfo,
} from "./../../api/exam_api";
export default {
  data() {
    return {
      tableData2: [],
      currentPage4: 1,
      radio3: 1,
      chartData: {
        columns: ["counttime", "countnum"],
        rows: [],
      },
      chartSettings: {
        labelMap: {
          countnum: "平均分",
        },
      },
      timeValue: [],
      data: {},
      testName: "",
      listData: [],
      testId: "",
      stepData: [],
      active: false,
      asList: [],
    };
  },
  methods: {
    pageSizeChange() {},
    pageChange() {},
    objectSpanMethod({ row, column, rowIndex, columnIndex }) {
      if (columnIndex === 0) {
        if (rowIndex % 3 === 0) {
          return {
            rowspan: 3,
            colspan: 1,
          };
        } else {
          return {
            rowspan: 0,
            colspan: 0,
          };
        }
      }
    },
    getNewTable($id) {
      let data = {
        classId: this.$route.query.type,
        relationId: this.$route.query.plan,
        examinationId: $id,
      };
      getClassExamInfo(data).then((res) => {
        if (res.code == 200 || res.code == 0) {
          let _height = 0;
          let that = this;
          if (res.data.examCount) {
            res.data.examCount.forEach(function (index, i) {
              _height = 0;
              index.itemStep.forEach(function (index, i) {
                index.stepHeight = 50;
                _height += index.stepHeight + 0.5;
              });
              index.nameHeight = _height;
            });
            this.data = res.data.examCount;
            this.asList = res.data.examCount;
          }
          if (this.data.name) {
            this.testName = this.data.name;
          }
        }
      });
    },
    getNewData($id) {
      let data2 = {
        //   type:this.radio3,
        classId: this.$route.query.type,
        // relationId:this.$route.query.plan,
        experimentId: this.$route.query.examId,
      };
      getClassExamListInfo(data2).then((res) => {
        if (res.code == 200 || res.code == 0) {
          this.listData = res.data;
          // this.listData[0].active = true;
          if (!$id) {
            $id = this.listData[0].examinationId;
          }
          this.listData.forEach((index, i) => {
            index.group_name = index.examination.name;
            index.avgScore.toFixed(1);
            index.ymd = this.GLOBAL.request.toTime(
              index.examination.addTime * 1000,
              2
            );
            if (index.examinationId == $id) {
              index.active = true;
            } else {
              index.active = false;
            }
          });
          this.getNewTable($id);
        }
      });
    },
    getData($typr) {
      this.data = [];
      this.stepData = [];
      let data2 = {
        //   type:this.radio3,
        classId: this.$route.query.type,
        // relationId:this.$route.query.plan,
        experimentId: this.$route.query.examId,
      };
      getClassExperimentStatistics(data2).then((res) => {
        this.chartData.rows = [];
        this.listData = [];
        if (res.code == 200 || res.code == 0) {
          for (let i in res.data) {
            let obj = {
              counttime: this.GLOBAL.request.toTime(
                res.data[i].addtime * 1000,
                1
              ),
              countnum:
                res.data[i].num == 0 ? 0 : res.data[i].score / res.data[i].num,
            };
            this.chartData.rows.push(obj);
            this.listData.push(res.data[i]);
          }
          if ($typr) {
            this.testId = $typr;
          } else {
            // debugger;
            this.testId = this.listData[0].id;
            this.listData[0].active = true;
          }
          let data = {
            classId: this.$route.query.type,
            relationId: this.$route.query.plan,
          };
          getClassExamInfo(data).then((res) => {
            if (res.code == 200 || res.code == 0) {
              let _height = 0;
              let that = this;
              if (res.data.examCount) {
                res.data.examCount.forEach(function (index, i) {
                  _height = 0;
                  index.itemStep.forEach(function (index, i) {
                    index.stepHeight = 50;
                    _height += index.stepHeight + 0.5;
                  });
                  index.nameHeight = _height;
                });
                this.data = res.data.examCount;
                this.asList = res.data.examCount;
              }
              if (this.data.name) {
                this.testName = this.data.name;
              }
            }
          });
          if (this.radio3 == 1) {
          } else {
            let _height = 0;
            let that = this;
            if (res.data.step) {
              res.data.step.forEach(function (index, i) {
                _height = 0;
                let _len = index.item.length;
                index.item.forEach(function (index, i) {
                  index.stepHeight = 50;
                  _height += index.stepHeight + 0.5;
                  if (index.comments) {
                    index.comments.forEach(function (index, i) {
                      that.stepData.push(index);
                    });
                  }
                });
                index.nameHeight = _height;
              });
              this.data.commentsList = res.data.comments;
              this.data.stepList = res.data.step;
              this.asList = res.data.step;
            }
            if (this.data.name) {
              this.testName = this.data.name;
            }
          }
        }
      });
      this.getNewData();
    },
  },
  mounted() {
    this.getData();
  },
};
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/assets/js/pages/exam/ExamListDetails.vue